const FeelingItems = [
    { "label": "开心", "icon": require('../icons/Feelings/开心.png'), "isFolder": false },
    { "label": "受伤", "icon": require('../icons/Feelings/受伤.png'), "isFolder": false },
    { "label": "害怕", "icon": require('../icons/Feelings/害怕.png'), "isFolder": false },
    { "label": "平安", "icon": require('../icons/Feelings/平安.png'), "isFolder": false },
    { "label": "悲伤", "icon": require('../icons/Feelings/悲伤.png'), "isFolder": false },
    { "label": "担心", "icon": require('../icons/Feelings/担心.png'), "isFolder": false },
    { "label": "无聊", "icon": require('../icons/Feelings/无聊.png'), "isFolder": false },
    { "label": "沮丧", "icon": require('../icons/Feelings/沮丧.png'), "isFolder": false },
    { "label": "激动", "icon": require('../icons/Feelings/激动.png'), "isFolder": false },
    { "label": "生气", "icon": require('../icons/Feelings/生气.png'), "isFolder": false },
    { "label": "生病", "icon": require('../icons/Feelings/生病.png'), "isFolder": false },
    { "label": "疲倦", "icon": require('../icons/Feelings/疲倦.png'), "isFolder": false },
    { "label": "饿", "icon": require('../icons/Feelings/饿.png'), "isFolder": false },
    { "label": "返回", "icon": require('../icons/HOME.png'), "isFolder": true }
  ];
  
  export default FeelingItems;
  